import {
  Base,
  Primary,
  Green,
  Secondary,
  Disabled,
  Red,
  RedInvert,
  BlueInvert,
  Blue,
  BorderBlue,
  BlueWhite,
  RedInvertWithBorder,
  RcGrey,
  RcBlue,
  RcLinkBlue,
  NeutralStrokePrimary,
  InfoFilled,
  DangerFilled,
  PrimaryFilled,
  NeutralGhost,
  PrimaryStroke,
  PrimaryGhost,
} from './styles';

type Variant = 'primary' | 'secondary' | 'blue-inv' | 'blue' | 'borderblue' | 'greendiel'| 'red' | 'red-inv' | 'disabled' | 'grey' | 'blue-white' | 'red-inv-border' | 'rc-grey' | 'rc-blue' | 'rc-link' | 'neutral-stroke-primary' | 'info-filled' | 'danger-filled' | 'primary-filled' | 'neutral-ghost' | 'primary-stroke' | 'primary-ghost';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &{
  variant?: Variant;
  children: JSX.Element | string;
}

export const Button = ({ variant, children, ...props }: ButtonProps): JSX.Element => {
  switch (variant) {
    case 'primary':
      return <Primary {...props}>{children}</Primary>;
    case 'secondary':
      return <Secondary {...props}>{children}</Secondary>;
    case 'blue-inv':
      return <BlueInvert {...props}>{children}</BlueInvert>;
    case 'blue':
      return <Blue {...props}>{children}</Blue>;
    case 'borderblue':
      return <BorderBlue {...props}>{children}</BorderBlue>;
    case 'greendiel':
      return <Green {...props}>{children}</Green>;
    case 'red-inv':
      return <RedInvert {...props}>{children}</RedInvert>;
    case 'blue-white':
      return <BlueWhite {...props}>{children}</BlueWhite>;
    case 'red':
      return <Red {...props}>{children}</Red>;
    case 'red-inv-border':
      return <RedInvertWithBorder {...props}>{children}</RedInvertWithBorder>;
    case 'rc-grey':
      return <RcGrey {...props}>{children}</RcGrey>;
    case 'rc-blue':
      return <RcBlue {...props}>{children}</RcBlue>;
    case 'rc-link':
      return <RcLinkBlue {...props}>{children}</RcLinkBlue>;
    case 'neutral-stroke-primary':
      return <NeutralStrokePrimary {...props}>{children}</NeutralStrokePrimary>;
    case 'info-filled':
      return <InfoFilled {...props}>{children}</InfoFilled>;
    case 'danger-filled':
      return <DangerFilled {...props}>{children}</DangerFilled>;
    case 'primary-filled':
      return <PrimaryFilled {...props}>{children}</PrimaryFilled>;
    case 'neutral-ghost':
      return <NeutralGhost {...props}>{children}</NeutralGhost>;
    case 'primary-stroke':
      return <PrimaryStroke {...props}>{children}</PrimaryStroke>;
    case 'primary-ghost':
      return <PrimaryGhost {...props}>{children}</PrimaryGhost>;
    case 'disabled':
      return (
        <Disabled disabled {...props}>
          {children}
        </Disabled>
      );
    default:
      return <Base {...props}>{children}</Base>;
  }
};
